import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ALERTS } from 'src/app/common';
import { AlertsService } from 'src/app/services/alerts.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SideBarService } from 'src/app/services/side-bar.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  isLogin: boolean;
  loading = false;
  //perms: IPermission[];
  
  constructor(private fb: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private alertsService: AlertsService,
    private storageService: StorageService, 
    private sidebarService: SideBarService
  ) {
    if (this.auth.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.initializePage();
  }

  initializePage() {
    this.isLogin = true;

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')]],
      password: ['', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get fLogin() { return this.loginForm.controls; }

  // funcion para el envio del formulario, tanto de login como de signin
  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    this.auth.login(this.fLogin.email.value, this.fLogin.password.value)
      .pipe(first())
      .subscribe(data => {
        this.loading = false;
        this.GetUserRole('');
        this.sidebarService.toggler.next(true);
        this.router.navigateByUrl('home');
      }, error => {
        this.loading = false;
        this.alertsService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
      });
  }

  GetUserRole(_userId: string): void {
  }

  getUserGeoConfigs() {
    let geoConfigs: any[] = [];
  }

}